function init(el) {
  const btns = $(this).find('.floor-btn');
  const slides = $(this).find('div[role="tabpanel"]');

  btns.each(function () {
    $(this).on('click', function () {
      btns.each(function () {
        $(this).attr('aria-selected', false);
      });
      $(this).attr('aria-selected', true);

      slides.each((key, el) => {
        if (key == $(this).data('index')) {
          $(el).removeClass('hide');
          el.hidden = false;
          return;
        }
        el.hidden = true;
        $(el).addClass('hide');
      });
    });
  });
}

export default function () {
  $('section[data-block=selling-points]').each(init);
}
